/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { groupBy } from 'rxjs';
import { BaseAccordionComponent } from '../base-accordion.component';
import { VisitDayDetailsService } from '../../visit-day-details.service';
import { AccordionService } from 'src/app/services/accordion.service';
interface Module {
  areaId: string;
  areaName: string;
  moduleName: string;
  cnt: number;
}

interface GroupedModule {
  areaId: string;
  children: { moduleName: string; cnt: number }[];
}

@Component({
  selector: 'app-visit-detail-modules',
  templateUrl: './visit-detail-modules.component.html',
  styleUrls: ['./visit-detail-modules.component.scss'],
})
export class VisitDetailModulesComponent
  extends BaseAccordionComponent
  implements OnInit
{
  @Input() visit;
  @Input()
  public visitId: number;
  @Input()
  public date: string;
  @Input()
  public dayNumber: string;
  @Output()
  saveSummaryField = new EventEmitter();
  public modules = [];

  constructor(private router: Router, accordionService: AccordionService) {
    super(accordionService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.modules = this.visit?.modules;
    if (this.modules) {
      this.modules = Object.entries(
        (this.modules as Module[]).reduce(
          (
            acc: Record<string, GroupedModule>,
            { areaId, areaName, moduleName, cnt }
          ) => {
            const key = areaName;
            if (!acc[key]) {
              acc[key] = {
                areaId,
                children: [],
              };
            }
            acc[key].children.push({ moduleName, cnt });
            return acc;
          },
          {}
        )
      ).map(([key, value]) => ({
        name: key,
        areaId: value.areaId,
        children: value.children,
      }));
    }
  }

  goToMap(areaId: string): void {
    this.saveSummaryField.emit();
    this.router.navigate([
      'area/',
      this.date,
      this.visitId,
      this.dayNumber,
      areaId,
    ]);
  }
}
